import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Badge } from '../../../components/ui/Badge';
import { BADGE_VARIANTS } from '../../../components/ui/badgeVariants';

/** Active / inactive account status as the shared themed dot + label badge. */
export function UserStatusBadge({ active }: { active: boolean }) {
  const { t } = useTranslation('users');
  const theme = useTheme();
  const { color, bgcolor, dot } = BADGE_VARIANTS[active ? 'success' : 'neutral'];

  return (
    <Badge
      label={active ? t('users:table.status.active') : t('users:table.status.inactive')}
      color={color}
      bgcolor={bgcolor}
      dot={dot}
      fontWeight={theme.typography.fontWeightSemiBold}
    />
  );
}
